import * as z from "zod"

// Schema para criação de equipe baseado na API
export const teamFormSchema = z.object({
  nome_setor: z.string().min(1, "Nome da equipe é obrigatório").min(3, "Nome deve ter pelo menos 3 caracteres"),
  cidade_fk: z.string().min(1, "Localização é obrigatória"),
  chefe_setor_fk: z.string().optional(), // Opcional, pode não ter líder definido
})

export type TeamFormValues = z.infer<typeof teamFormSchema>

// Schema para a API request
export const createEquipeRequest = z.object({
  nome_setor: z.string(),
  cidade_fk: z.number(),
  chefe_setor_fk: z.number().optional(),
})

export type CreateEquipeRequest = z.infer<typeof createEquipeRequest>